import { store } from 'redux/store'
import { PlaytesterV2State } from '../types'

const sharableFields: (keyof Partial<PlaytesterV2State>)[] = [
  // Zones
  'battlefield',
  'hand',
  'library',
  'sideboard',
  'graveyard',
  'exile',
  'commandZone',
  'attractions',
  'junkyard',
  'planes',

  // Coordinates (this is a special case)
  'cardCoordinates',

  // Action options
  'selected',
  'showPopoutHand',
  'showOverlaysInPopout',

  // Overlays
  'peeking',
  'searching',
  'cardSearch',
  'allTokensOverlay',
  'randomGeneratorOverlay',
  'randomGeneratedValues',
  'generatingRandomValue',
  'openingHandOverlay',
  'customCardCreationOverlay',
  'stackDeckOverlay',
  'searchOverlaySearchValue',

  // Counters
  'lifeTotal',
  'lifeTotal2',
  'commanderDamangeOne',
  'commanderDamangeTwo',
  'commanderDamangeThree',
  'commanderDamangeFour',

  'turnCounter',
  'infectDamage',
  'experiance',

  'energy',
  'whiteMana',
  'blueMana',
  'blackMana',
  'redMana',
  'greenMana',
  'colorlessMana',

  // User settings
  'playmatColor',
  'playmatColorExtendsToLowerThird',
  'playmatUrl',
  'sleevesColor',
  'sleevesUrl',
]

export const generateSharablePlaytesterState = (
  partialPlaytesterState: Partial<PlaytesterV2State>,
): Partial<PlaytesterV2State> | null => {
  // @ts-ignore
  const alteredFields: (keyof PlaytesterV2State)[] = Object.keys(partialPlaytesterState)
  const cacheableInfo = alteredFields.reduce((acc, field) => {
    if (!sharableFields.includes(field)) return acc

    // @ts-ignore
    acc[`${field}`] = partialPlaytesterState[field]

    return acc
  }, {} as Partial<PlaytesterV2State>)

  if (!Object.keys(cacheableInfo).length) return null // skip writting to local storage unless there's anything new to write

  return cacheableInfo
}

// export const cleanupSharedPlaytesterState = (partialPlaytesterState: Partial<PlaytesterV2State>): Partial<PlaytesterV2State> => {
//   if (!partialPlaytesterState.cardCoordinates)

//   const currentCardCoordinates = store.getState().playtesterV2.cardCoordinates

//   return { ...partialPlaytesterState, }
// }
